PegasusTemplate.NoRowsView = Em.View.extend({
  classNames: ['vr-no-rows'],
  templateName: 'controls/no_rows',
  dragOver: function(){
    this.$().addClass('hovered');
  },
  dragLeave: function(e){
    this.$().removeClass('hovered');
  }
});
